<script>
import { Icon } from 'ant-design-vue'
import STable from '@/components/Table/'
import { changeUserMembership, loadPermissionList, switchEmailAlertEnable, toggleSharePermissionStatus } from '@/api/data'
import QrBind from '@/views/data/modal/QrBind.vue'
import EmailBind from '@/views/data/modal/EmailBind.vue'
import UserProfile from '@/views/data/modal/UserProfile.vue'
import MembershipUpgrade from '@/views/data/modal/MembershipUpgrade.vue'
import CreateAccount from '@/views/data/modal/CreateAccount.vue'
import ResetPassword from '@/views/data/modal/ResetPassword.vue'
import moment from 'moment'
import MembershipUpgradeBatch from '@/views/data/modal/MembershipUpgradeBatch.vue'
import { getI18nLanguage } from '@/locales'

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4667817_6r4uyhchvik.js'
})
export default {
  name: 'DriverList',
  components: {
    STable,
    IconFont
  },
  data () {
    return {
      expireNum: 0,
      col: {
        lg: 8,
        xl: 6
      },
      locale: {
        emptyText: this.$t('table.emptyText')
      },
      columns: [{
        title: this.$t('user.name'),
        dataIndex: 'name',
        align: 'center',
        key: 'name'
      }, {
        title: this.$t('user.org.name'),
        dataIndex: 'org_name',
        align: 'center',
        key: 'org_name'
      }, {
        title: this.$t('user.account'),
        dataIndex: 'account',
        align: 'center',
        key: 'account'
      }, {
        title: this.$t('user.email.alert'),
        dataIndex: 'email_alert',
        align: 'center',
        key: 'email_alert',
        scopedSlots: { customRender: 'email_alert' },
        width: 120
      }, {
        title: this.$t('user.membership.level'),
        dataIndex: 'level',
        align: 'center',
        width: 180,
        scopedSlots: { customRender: 'level' },
        key: 'level'
      }, {
        title: this.$t('user.membership.expire.time'),
        dataIndex: 'level_expire',
        align: 'center',
        width: 160,
        scopedSlots: { customRender: 'expire' },
        key: 'level'
      }, {
        title: this.$t('user.share.status'),
        dataIndex: 'status',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'status' },
        key: 'status'
      }, {
        title: this.$t('user.bindTime'),
        dataIndex: 'create_time',
        align: 'center',
        width: 160,
        key: 'create_time'
      }, {
        title: this.$t('user.action'),
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' },
        width: 310,
        fixed: 'right',
        align: 'center',
        key: 'action'
      }],
      queryParams: {
        name: ''
      },
      loadData: (paramter) => {
        return loadPermissionList(Object.assign(this.queryParams, paramter)).then(res => {
          return res.result
        })
      },
      selectedRowKeys: [],
      selectedRows: [],
      isCN: getI18nLanguage() === 'zh-CN'
    }
  },
  created () {
    this.checkExpireNum()
  },
  methods: {
    moment,
    reloadTable () {
      this.$refs.table.refresh(true)
      this.checkExpireNum()
    },
    refreshTable () {
      this.$refs.table.refresh()
      this.checkExpireNum()
    },
    checkExpireNum () {
      loadPermissionList({ pageNo: 1, pageSize: 100 }).then(res => {
        const ds = res.result.data
        let expireNum = 0
        for (const d of ds) {
          if (d.user_level === 0 || moment(d.level_expire).diff(moment(), 'days') <= 5) {
            expireNum++
          }
        }
        this.expireNum = expireNum
      })
    },
    handleMenuClick (e) {
      switch (e.key) {
        case '1':
          this.showModal(QrBind, this.$t('user.action.scanBind'), 360, 400)
          break
        case '2':
          this.showModal(EmailBind, this.$t('user.action.emailBind'), 500, 500)
          break
      }
    },
    // 不再提供删除司机功能, 只能禁用/启用(冻结/解冻司机账号, 保留绑定关系)
    toggleStatus (record) {
      const status = record.user_status === 1 ? 0 : 1
      this.doToggleStatus({ id: record.id, status: status })
    },
    toggleMultiple (status) {
      const doToggle = () => this.doToggleStatus({ id: this.selectedRowKeys, status })
      if (status === 0) {
        this.$confirm({
          title: this.$t('user.action.disable.batch.title'),
          content: this.$t('user.action.disable.content'),
          okText: this.$t('user.action.ok'),
          cancelText: this.$t('user.action.cancel'),
          onOk: doToggle
        })
      } else {
        doToggle()
      }
    },
    doToggleStatus (param) {
      toggleSharePermissionStatus(param).then(res => {
        this.refreshTable()
      })
    },
    showUserProfile (uid, editable) {
      this.showModal(UserProfile, this.$t('user.profile'), 700, this.isCN ? 300 : 600, { uid: uid, editable })
    },
    search () {
      this.$refs.table.refresh()
    },
    upgrade (record) {
      this.showModal(MembershipUpgrade, this.$t('user.membership.upgrade'), 800, 520, { record: record })
    },
    switchMembership (record) {
      changeUserMembership({ userid: record.user_id, user_level: record.user_level === 2 ? 1 : 2 }).then(res => {
        this.refreshTable()
      })
    },
    handeChangeSwitch (e, record) {
      switchEmailAlertEnable({
        email_alert: e ? 1 : 0,
        id: record.id
      }).then(res => {
        this.refreshTable()
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    upgradeMultiple () {
       this.showModal(MembershipUpgradeBatch, this.$t('user.membership.upgrade'), 800, 520, { selectedRows: this.selectedRows })
    },
    showCreateAccount () {
      this.showModal(CreateAccount, this.$t('user.action.driverCreate'), 500, 400)
    },
    showResetPassword (record) {
      this.showModal(ResetPassword, this.$t('user.password.reset'), 500, 400, { record: record })
    }
  }
}
</script>

<template>
  <div class="driver-list-page">
    <div class="filter-card">
      <div class="filter-card__body">
        <a-row :gutter="16">
          <a-col :lg="col.lg" :xl="col.xl">
            <div class="filter-item">
              <label class="filter-item__label">{{ $t('user.name') }}</label>
              <a-input class="filter-item__input" v-model="queryParams.name" allowClear @pressEnter="search" />
            </div>
          </a-col>
          <a-col :lg="col.lg" :xl="col.xl">
            <div class="filter-item filter-item--actions">
              <a-button @click="search">{{ $t('user.action.search') }}</a-button>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <div class="table-card">
      <a-alert
        v-if="expireNum > 0"
        class="table-card__alert"
        :message="$t('user.membership.expire.alert').replace('{num}', expireNum)"
        type="warning"
        show-icon
        closable />
      <div class="table-card__toolbar">
        <div class="table-card__actions">
          <a-button icon="plus" type="primary" @click="showCreateAccount">{{ $t('user.action.driverCreate') }}</a-button>
          <a-dropdown>
            <a-menu slot="overlay" @click="handleMenuClick">
              <a-menu-item key="1">
                <a-icon type="qrcode" />
                {{ $t('user.action.scanBind') }}
              </a-menu-item>
            </a-menu>
            <a-button icon="link">{{ $t('user.action.bind') }}</a-button>
          </a-dropdown>
          <a-button :disabled="selectedRowKeys.length === 0" icon="stop" @click="toggleMultiple(0)">{{ $t('user.action.disable.batch') }}</a-button>
          <a-button :disabled="selectedRowKeys.length === 0" icon="check-circle" @click="toggleMultiple(1)">{{ $t('user.action.enable.batch') }}</a-button>
          <a-button icon="arrow-up" :disabled="selectedRowKeys.length === 0" @click="upgradeMultiple">{{ $t('user.membership.upgrade.multiple') }}</a-button>
        </div>
        <span v-if="selectedRowKeys.length > 0" class="table-card__state">{{ $t('table.selected').replace('{count}', selectedRowKeys.length) }}</span>
      </div>
      <s-table
        :columns="columns"
        :data="loadData"
        :locale="locale"
        ref="table"
        :rowKey="record => record.id"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: 1700 }">
        <span slot="status" slot-scope="text, record">
          <span v-if="record.user_status === 1" class="status-badge status-badge--enable">
            <span class="status-badge__dot"></span>{{ $t('user.share.status.enable') }}
          </span>
          <span v-else class="status-badge status-badge--disable" :title="$t('user.share.status.disable.tip')">
            <span class="status-badge__dot"></span>{{ $t('user.share.status.disable') }}
          </span>
        </span>
        <span slot="expire" slot-scope="text, record" class="cell-muted">
          {{ record.user_level > 0 ? moment(record.level_expire).format('YYYY-MM-DD HH:mm:ss') : '-' }}
        </span>
        <span slot="email_alert" slot-scope="text, record">
          <a-switch :checked="record.email_alert === 1" @change="handeChangeSwitch($event, record)" />
        </span>
        <div slot="level" slot-scope="text, record">
          <div v-if="record.membership_switch_enable">
            <a-dropdown :trigger="['hover']">
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <span v-if="record.user_level === 1" class="level-badge level-badge--pro">
                  <span class="level-badge__dot"></span>{{ $t('user.membership.level.pro') }}
                  <a-icon type="down" class="level-badge__arrow"></a-icon>
                </span>
                <span v-if="record.user_level === 2" class="level-badge level-badge--plus">
                  <span class="level-badge__dot"></span>{{ $t('user.membership.level.plus') }}
                  <a-icon type="down" class="level-badge__arrow"></a-icon>
                </span>
              </a>
              <a-menu slot="overlay">
                <a-menu-item key="0">
                  <a @click="switchMembership(record)" v-if="record.user_level === 1">{{ $t('user.membership.switchTo.plus') }}</a>
                  <a @click="switchMembership(record)" v-if="record.user_level === 2">{{ $t('user.membership.switchTo.pro') }}</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <div v-else>
            <span v-if="record.user_level === 0" class="level-badge level-badge--trial">
              <span class="level-badge__dot"></span>{{ $t('user.membership.level.trial') }}
            </span>
            <span v-if="record.user_level === 1" class="level-badge level-badge--pro">
              <span class="level-badge__dot"></span>{{ $t('user.membership.level.pro') }}
            </span>
            <span v-if="record.user_level === 2" class="level-badge level-badge--plus">
              <span class="level-badge__dot"></span>{{ $t('user.membership.level.plus') }}
            </span>
          </div>
        </div>
        <div slot="action" slot-scope="text, record" class="action-cell">
          <a-button v-if="record.user_status === 1" type="link" class="action-link--danger" @click="toggleStatus(record)">{{ $t('user.action.disable') }}</a-button>
          <a-button v-else type="link" @click="toggleStatus(record)">{{ $t('user.action.enable') }}</a-button>
          <span class="action-divider"></span>
          <a-button type="link" class="action-link--upgrade" @click="upgrade(record)">{{ $t('user.membership.upgrade') }}</a-button>
          <span class="action-divider"></span>
          <a-dropdown :trigger="['click']">
            <a-button type="link">
              {{ $t('user.action.more') }}
              <a-icon type="down" />
            </a-button>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="showUserProfile(record.user_id, record.creator !== null)">{{ $t('user.profile') }}</a>
              </a-menu-item>
              <a-menu-item v-if="record.creator">
                <a @click="showResetPassword(record)">{{ $t('user.password.reset') }}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </s-table>
    </div>
  </div>
</template>

<style scoped lang="less">
// 筛选条 + 数据卡的骨架（配色、圆角、投影、标签堆叠、工具条、卡片节奏）
// 十个列表页共用一份，见 assets/list-page.less
@import '../../assets/list-page.less';

// 会员等级只有这一页用，不进全局令牌
@tier-plus-tint: #fffbe6;
@tier-plus-ink: #6f5701;

/* ── 状态徽标 ── */
.status-badge {
  .badge-base();

  // 字用 *-ink、点用信号色：骨架里统一这个分工
  &--enable {
    color: var(--pass-ink);
    background: var(--pass-tint);

    .status-badge__dot {
      background: var(--pass);
    }
  }

  &--disable {
    color: var(--fail-ink);
    background: var(--fail-tint);

    .status-badge__dot {
      background: var(--fail);
    }
  }
}

/* ── 等级徽标 ── */
.level-badge {
  .badge-base();

  &__arrow {
    font-size: 10px;
    margin-left: 2px;
  }

  &--trial {
    color: var(--ink-2);
    background: var(--line-2);

    .level-badge__dot {
      background: var(--ink-3);
    }
  }

  &--pro {
    color: var(--warn-ink);
    background: var(--warn-tint);

    .level-badge__dot {
      background: var(--warn);
    }
  }

  &--plus {
    color: @tier-plus-ink;
    background: @tier-plus-tint;

    .level-badge__dot {
      background: #f0b400;
    }
  }
}

/* ── 操作列 ── */
// 文字按钮的盒子、竖线、「删除」的红色都在骨架里；升级不是删除，
// 它是让人往更高的等级走，所以这一档暖色留在本页
.action-cell /deep/ .ant-btn-link.action-link--upgrade {
  color: var(--warn-ink);

  &:hover,
  &:focus {
    color: var(--warn);
  }
}
</style>
